import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../src/environments/env';

@Injectable({
  providedIn: 'root'
})
export class HelprequestService {

  private apiUrl = environment.BASE_URL+`/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  constructor(private http: HttpClient) { }

  public helpSubmit(payload:any): Observable<any> {
    return this.http.post<any>( this.apiUrl +`api/spp/dashboard/help-desk`, payload, 
    { headers: {
        'Access-Control-Allow-Origin':'*'
      }
    });
  }
  
}
